'use strict';
var MemberApp = angular.module('MemberApp');

/*
 * Ensure that we reconstitute the user object if we have a valid otppSession.
 *
 * @see https://github.com/angular-ui/ui-router/wiki/Quick-Reference#urlroutersync
 */
MemberApp.run(function($rootScope, $state, $q, $http, $translate, $location, $injector, urlService,
  $cookies, adobeAnalyticsService,otppConstants, userStore) {

  let localStorageEnabled = $injector.get('localStorageEnabled');
  let cookiesEnabled = $injector.get('cookiesEnabled');
  let currentPage;

  if ($cookies.get('calcDate')) {
    var calcDateIndicator = angular.element('<div></div>').text('calcDate: ' + $cookies.get('calcDate'));
    calcDateIndicator.css({
      position: 'fixed',
      bottom: '10px',
      left: '10px',
      background: 'rgba(255,0,0,0.65)',
      padding: '10px',
      border: '2px solid black'
    });
    angular.element(document.body).append(calcDateIndicator);
  }

  function setCanonicalUrl(stateName) {
    var canonical = angular.element('link[rel=canonical]');
    if (canonical.length === 0) {
      canonical = angular.element('<link>');
      canonical.attr('rel', 'canonical');
      angular.element('head').append(canonical);
      canonical = angular.element('link[rel=canonical]');
    }

    var url = $location.protocol() + '://' + $location.host()+ $state.href(stateName);
    canonical.attr('href', url);
  }

  function setPageTitle(translationKey) {
    var title = angular.element('title');
    $q.all([$translate('titles.' + translationKey), $translate('title')]).then(function(translations) {
      if ($cookies.get(otppConstants.bamKey)) {
        title.text(userStore.getFirstName() + ' - ' + translations[0] + ' - ' + translations[1]);
      } else {
        title.text(translations[0] + ' - ' + translations[1]);
      }
    }, function() {
      setPageTitle('default');
    });
  }

  function redirectToGetCookiesPage() {
    var language;
    if (navigator.languages) {
      language = navigator.languages[0];
    } else {
      language = navigator.language || navigator.userLanguage;
    }

    if (language.indexOf('fr') > -1) {
      urlService.pageRedirect('//fr-ca/ns/no-cookies/');
    } else {
      urlService.pageRedirect('//en-ca/ns/no-cookies/');
    }
  }

  function toggleHtmlLangAttribute() {
    let htmlEl = angular.element('html');
    let currentLang = htmlEl.attr('lang');

    if ($cookies.get('language')) {
      currentLang = $cookies.get('language');
    }

    htmlEl.attr('lang', currentLang);
  }

  $rootScope.$on('languageSwitched', function() {
    if (typeof QSI !== 'undefined') {
      QSI.API.unload();
    }

    setPageTitle($state.current.name);
    toggleHtmlLangAttribute();

    if (typeof QSI !== 'undefined') {
      QSI.API.load();
      QSI.API.run();
    }
  });

  $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState) => {
    if (typeof QSI !== 'undefined') {
      QSI.API.unload();
    }

    if (!cookiesEnabled) {
      redirectToGetCookiesPage();
    }
  });

  function verifyNoPendingRequests() {
    var deferred = $q.defer();
    var unbindWatcher = $rootScope.$watch(function() {
      return $http.pendingRequests.length;
    }, function() {
      if ($http.pendingRequests.length === 0) {
        deferred.resolve();
        unbindWatcher();
      }
    });
    return deferred.promise;
  }

  $(document.documentElement).off('analyticsStateChange');
  $(document.documentElement).on('analyticsStateChange', event => {
    adobeAnalyticsService.trackStateChange(event.detail.pageName, event.detail.channel, false);
  });

  $(document.documentElement).off('terminationOptionsStepChange');
  $(document.documentElement).on('terminationOptionsStepChange', event => {
    adobeAnalyticsService.trackStateChange(event.detail.pageName, event.detail.channel, false);
  });

  $rootScope.$on('$stateChangeSuccess', function(event, toState) {
    setCanonicalUrl(toState.name);
    setPageTitle(toState.name);

    $q.all([$translate('pageName.' + toState.name), verifyNoPendingRequests()]).then(
      (promisesReturnValues) => {
        var pageName = promisesReturnValues[0];
        var storageDisabled = !localStorageEnabled;

        // Fire analytics once only. We have to do this because we listen on $rootScope.
        if (currentPage === undefined || currentPage !== toState.name || currentPage === 'home') {
          currentPage = toState.name;
          adobeAnalyticsService.trackStateChange(pageName, toState.name, storageDisabled, event);
        }

        if (typeof QSI !== 'undefined' && QSI.API) {
          QSI.API.load();
          QSI.API.run();
        }

        // add tabbing start dummy element,fix DMWS-301
        if ($('div#__tabStart').length >= 1) {
          //$stateProvider will persist tabStart element across state change
          //need to remove it from DOM to refresh the tab focus of whole page
          $('div#__tabStart').remove();
        }
        $('<div id="__tabStart" tabindex="0"></div>').prependTo('body')[0].focus();
      });
  });

  $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState) {
    if (typeof QSI !== 'undefined') {
      QSI.API.unload();
    }

    if (typeof QSI !== 'undefined') {
      QSI.API.load();
      QSI.API.run();
    }
  });

  toggleHtmlLangAttribute();
});

